import { Box } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ScreenerBoardView } from './board/ScreenerBoardView';
import { AssetRoute } from './asset/AssetRoute';
import { AssetResolver } from './asset/AssetResolver';
import { EventView } from './views/EventView';
import { EventRoute } from './event/EventRoute';
import { MarketView } from './views/MarketView';
import { SearchView } from './search/SearchView';

export function MarketsView() {
    return (
        <Box sx={{ height: '100%', minHeight: 0 }}>
            <Routes>
                <Route index element={<ScreenerBoardView />} />
                <Route path="search" element={<SearchView />} />
                <Route
                    path="asset/:assetType/:ticker"
                    element={<AssetRoute />}
                />
                <Route path="asset/:ticker" element={<AssetResolver />} />
                <Route path="event/:eventId" element={<EventRoute />} />
                {/* Legacy route — redirect to Event View */}
                <Route path="market/:id" element={<MarketView />} />
            </Routes>
        </Box>
    );
}